import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import { t } from '../../../../modules/infra/i18n';
import CustomersList from './CustomersList';
import DatePicker from '../../../common/DatePicker';
import SimpleHeader from '../../headers/simpleHeader';
import DateSwitcher from '../../../common/DateSwitcher';

const WaitingList = ({
  customers,
  setCurrentDate,
  currentDate,
  startDate,
  endDate,
  isFetching,
  heading,
  showBarber,
}) => (
  <div className="u-color-white u-p- u-max-width-710">
    <SimpleHeader heading={heading || t('appointment:waiting_list.default_heading')} />
    <div className="layout layout--flush layout--right layout--auto">
      <div className="layout__item">
        <DateSwitcher
          changeDate={setCurrentDate}
          currentDate={currentDate}
          startDate={startDate}
          endDate={endDate}
          disabled={isFetching}
        />
      </div>
      <div className="layout__item u-font-color-primary">
        <DatePicker
          component="button"
          onChange={setCurrentDate}
          startDate={moment(startDate).toDate()}
          endDate={moment(endDate).toDate()}
          day={currentDate}
          iconSize="medium"
          disabled={isFetching}
        />
      </div>
    </div>
    <CustomersList customers={customers} display-if={!isFetching} showBarber={showBarber} />
  </div>
);
WaitingList.propTypes = {
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  ),
  setCurrentDate: PropTypes.func.isRequired,
  currentDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  isFetching: PropTypes.bool.isRequired,
  heading: PropTypes.string,
  showBarber: PropTypes.bool,
};
WaitingList.defaultProps = {
  customers: [],
  heading: null,
  showBarber: false,
};

export default WaitingList;
